import { render, staticRenderFns } from "./detailsInventoryLoss.vue?vue&type=template&id=b290ce3e&scoped=true"
import script from "./detailsInventoryLoss.vue?vue&type=script&lang=js"
export * from "./detailsInventoryLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b290ce3e",
  null
  
)

export default component.exports